// components/Footer.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import './styles/footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-columns">
          {/* Column 1 - Brand */}
          <div className="footer-column footer-brand">
            <div className="footer-logo">
              <img src="/logo.png" alt="Mangold" />
            </div>
            <p className="footer-tagline">
              Minimalist technology design studio combining advanced aesthetics with clear systems.
            </p>
            <div className="footer-social">
              <a href="https://www.linkedin.com/company/mangold-inc" target="_blank" rel="noopener noreferrer" className="social-link">LinkedIn</a>
            </div>
          </div>

          {/* Column 2 - Services */}
          <div className="footer-column">
            <h4 className="footer-column-title">Services</h4>
            <ul className="footer-links">
              <li><a href="#services">Brand Strategy</a></li>
              <li><a href="#services">UI/UX Design</a></li>
              <li><a href="#services">Development</a></li>
              <li><a href="#services">Motion Design</a></li>
              <li><a href="#services">Digital Marketing</a></li>
            </ul>
          </div>

          {/* Column 3 - Company */}
          <div className="footer-column">
            <h4 className="footer-column-title">Company</h4>
            <ul className="footer-links">
              <li><a href="#work">Our Work</a></li>
              <li><a href="#process">Process</a></li>
              <li><a href="#about">About Us</a></li>
            </ul>
          </div>

          {/* Column 4 - Contact */}
          <div className="footer-column">
            <h4 className="footer-column-title">Contact</h4>
            <ul className="footer-links">
              <li><a href="mailto:info@mangold.ai">info@mangold.ai</a></li>
              <li>Dover, DE, USA</li>
              <li>1111b South Governors Ave, STE 48507</li>
            </ul>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="footer-bottom">
          <div className="footer-bottom-left">
            <p>&copy; 2026 Mangold, Inc. All rights reserved.</p>
          </div>
          <div className="footer-bottom-right">
            <Link to="/privacy">Privacy Policy</Link>
            <Link to="/terms">Terms of Service</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;